export default {
  affiliate: {
    // Main navigation
    title: 'ملحق',
    cantFindQuestion: 'سوال نہیں مل رہا؟',
    onlineService: 'آن لائن سروس',
    dashboard: 'ڈیش بورڈ',
    myRewards: 'میرے انعامات',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: 'دعوت نامے کے انعامات',
    rules: 'قواعد',

    // Team Info
    teamData: 'ٹیم کا ڈیٹا',
    details: 'تفصیلات',
    totalValidFriends: 'کل درست دوست:',
    todayTotalWager: 'آج کی کل شرط:',
    rewards: 'انعامات',

    // Commission rates
    inviteFriendsCommissionUpTo: 'دوستوں کو مدعو کرنے کا کمیشن تک',
    expandTeamBonus: 'ٹیم توسیع بونس',
    maxLevelCommission: 'زیادہ سے زیادہ سطح کمیشن',
    inviteFriendsCommission: 'دوستوں کو مدعو کرنے کا کمیشن',
    maxPerformanceCommission: 'زیادہ سے زیادہ کارکردگی کمیشن',
    unlimitedAgent: 'لامحدود ایجنٹ',
    unlimitedCommission: 'لامحدود کمیشن',
    commissionRate: 'کمیشن کی شرح',

    // Team Invite Friends
    inviteFriendsToEarn: 'کمانے کے لیے دوستوں کو مدعو کریں',
    link: 'لنک',
    code: 'کوڈ',
    inviteFriends: 'دوستوں کو مدعو کریں',
    share: 'شیئر کریں',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'دعویٰ کریں',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'آج موصول ہوا',
    
    liveRewards: 'Live Rewards',
    sendTotalCommission: 'کل کمیشن بھیجیں',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'آج مدعو کردہ دوست',
    todayDepositFriends: 'آج جمع کرنے والے دوست',
    depositFriends: 'جمع کرنے والے دوست',
    validFriends: 'درست دوست',

    // Dialogs
    shareInvitationLink: 'اپنا دعوت نامہ لنک شیئر کریں تاکہ وہ رجسٹر ہو سکیں۔',
    shareInvitationCode: 'اپنا دعوت نامہ کوڈ شیئر کریں تاکہ وہ رجسٹریشن کے دوران داخل کر سکیں۔',
    shareQRCode: 'اپنا QR کوڈ شیئر کریں تاکہ وہ اسکین کر کے رجسٹر ہو سکیں۔',

    // Share Dialog
    shareTitle: 'شیئر کریں',
    player: 'کھلاڑی',
    saveImage: 'تصویر محفوظ کریں',
    saveImageSuccess: "تصویر محفوظ ہو گئی",
    saveImageFailed: "محفوظ کرنے میں ناکام، دوبارہ کوشش کریں",
    copy: 'کاپی کریں',
    copied: 'کاپی ہو گیا!',

    // Received/Withdraw
    received: 'موصول ہوا',
    withdraw: 'واپس لیں',
    history: 'تاریخ',
    referralRewards: 'حوالہ انعامات',
    commission: 'کمیشن',
    depositRebate: 'جمع رقم کی چھوٹ',
    levelUpRewards: 'لیول اپ انعامات',
    loading: 'لوڈ ہو رہا ہے...',
    noMoreRecords: 'مزید کوئی ریکارڈ نہیں',
    loadMore: 'مزید لوڈ کریں',
    pending: 'زیر التواء',
    paid: 'ادا کیا گیا',
    rejected: 'مسترد',
    unknown: 'نامعلوم',
    upgradeReward: 'لیول اپ انعام',
    cancelled: 'منسوخ',
    receiving: 'موصول ہو رہا ہے',
    failed: 'ناکام',
    expired: 'میعاد ختم',

    // History Dialog
    pickDate: 'تاریخ منتخب کریں',
    select: 'منتخب کریں',
    chooseBonus: 'بونس منتخب کریں',
    all: 'تمام',

    // Invitation Rewards Page
    yourFriendGet: 'آپ کا دوست حاصل کرتا ہے',
    dailyInvitations: 'روزانہ دعوت نامے',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'ملحق انعامات کیسے حاصل کریں؟',
    shareToFriends: 'دوستوں کے ساتھ شیئر کریں',
    shareReferralLink: 'اپنے دوستوں کے ساتھ اپنا ریفرل لنک، کوڈ یا QR کوڈ شیئر کریں',
    friendsSignUpDeposit: 'دوست سائن اپ کریں اور جمع کریں',
    inviteFriendsRegisterDeposit: 'دوستوں کو AFUN پر رجسٹر کرنے اور پہلی جمع کرنے کی دعوت دیں۔',
    getUpTo: 'تک حاصل کریں',
    earnBigRewards: 'جب دوست شرط لگائیں، جمع کریں اور VIP تک پہنچیں تو انعامات اور کمیشن کمائیں۔',
    noticeEnsureCorrect: 'نوٹس: یقینی بنائیں کہ دعوت نامہ لنک، QR کوڈ، یا کوڈ درست ہے۔',

    // Rules - Commission Work
    howCommissionWork: 'کمیشن کیسے کام کرتا ہے؟',
    agentRatingDescription: 'ایجنٹ درجہ بندی کی تفصیل',
    you: 'آپ',
    commissionDescription: 'اپنے دوستوں B، C، D اور اس سے آگے کے ڈپازٹ اور شرطوں سے کمیشن کمائیں۔ کمیشن کی شرحوں کے لیے دائیں طرف کا چارٹ دیکھیں۔',
    claimConditions: 'دعویٰ کی شرائط',
    teamLevel: 'ٹیم کی سطح',
    earnUpTo: "Earn up to",
    expandYourTeam: "اپنی ٹیم بڑھائیں",
    earnAnExtra: "اضافی کمائیں",
    upgradeAgentLevel: "اپنا ایجنٹ لیول بڑھائیں",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'کل سائز',
    teamWager: 'ٹیم کی شرط',
    rebateRewardVary: 'چھوٹ کا انعام اور ٹاپ اپ انعام اس دن آپ کی ٹیم کی سطح کی بنیاد پر مختلف ہوتے ہیں۔',
    teamSizeDescription: 'ٹیم کا سائز: آپ کے پاس فی الوقت درست صارفین کی تعداد۔',
    teamBettingDescription: 'ٹیم کی شرط: آپ کے ماتحت افراد ایک دن میں جو کل شرطیں لگاتے ہیں۔',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'ٹیم کمیشن',
    teamCommissionSubTitle: 'اپنے نیٹ ورک کی ہر ڈپازٹ اور\nہر شرط سے کمائیں۔',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'دوستوں کو مدعو کریں، اور دونوں کو انعامات ملیں گے',
    inviteRegisterReceive: 'کامیابی سے دوستوں کو رجسٹر کرنے کی دعوت دیں اور وصول کریں',
    friendDepositWagerUnlock: 'جب آپ کا دوست 10.00 USDT جمع کرتا ہے اور 50.00 USDT کی شرط لگاتا ہے، تو آپ 3.00 USDT کا انعام کھول دیتے ہیں، اور آپ کے دوست کو 2.00 USDT ملتا ہے۔',
    inviteFriendToGet: 'حاصل کرنے کے لیے دوست کو مدعو کریں',
    inviteFriendsEarnRewards: 'دوستوں کو مدعو کریں اور انعامات حاصل کریں',
    howMakeFriendsSubordinates: 'دوستوں کو اپنے ماتحت بنانے کا طریقہ:',
    howMakeFriendsValidUsers: 'اپنے دوستوں کو درست صارفین بنانے کا طریقہ:',
    successfullyInviteFriends: 'کامیابی سے دوستوں کو سائن اپ کرنے کی دعوت دیں۔',
    cumulativeDepositsReach: 'ان کی مجموعی جمع 10.00 USDT تک پہنچ جاتی ہے۔',
    cumulativeValidBetsReach: 'ان کی مجموعی درست شرطیں 50.00 USDT تک پہنچ جاتی ہیں۔',
    thenBecomeValidUsers: 'پھر، وہ درست صارفین بن جائیں گے۔',
    depositFriendsDescription: 'جب آپ کے ماتحت دوست کامیابی سے رقم جمع کرتے ہیں، تو وہ جمع کرنے والے دوست بن جائیں گے۔',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'حالیہ مدعو کردہ دوست',
    recentDepositFriends: 'حالیہ جمع کرنے والے دوست',
    today: 'آج',
    yesterday: 'کل',
    thisMonth: 'اس مہینے',
    friendsData: 'دوستوں کا ڈیٹا',
    joinDate: 'شمولیت کی تاریخ',
    search: 'تلاش کریں',
    level: 'سطح',
    tier: 'درجہ',
    affiliateTreasureBox: 'ملحق خزانہ باکس',
    referralRewardsDesc: 'جب آپ دوستوں کو رجسٹر کرنے کی دعوت دیتے ہیں، تو آپ اور آپ کے دوست دونوں کو فراخدلانہ بونس ملیں گے۔',
    commissionDesc: 'آپ اور آپ کی ٹیم مل کر اپنے اہداف حاصل کرتے ہیں اور فراخدلانہ کمیشن کماتے ہیں۔',
    affiliateTreasureBoxDesc: 'سنگ میل بونس حاصل کرنے کے لیے دوستوں کو مدعو کریں',
  }
};
